import catalog from "./components/catalog-page.vue";
import categories from "./components/categories-page.vue";
import orders from "./components/orders-list-page.vue";
import newOrder from "./components/new-order.vue";

export default {
  routes: [
    {
      path: "/",
      component: catalog,
      name: "catalog",
    },
    {
      path: "/catalog/:id",
      component: categories,
      name: "categories",
    },
    {
      path: "/orders/:id",
      component: orders,
      name: "orders",
    },
    {
      path: "/document/:id",
      component: newOrder,
      name: "existingOrder",
    },
  ],
};
